// extracted by mini-css-extract-plugin
export var copyable = "_x-1";
export var explainable = "_x-0";
export var negative = "_x-2";
export var positive = "_x-3";